import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import '../styles/Brands.css';

const brandList = [
  { name: 'waaw fashion', logo: 'atml-waaw-fashion.png' },
  { name: 'Bakeman’s Biscuits', logo: 'abl-bakemans-biscuits.png' },
  { name: 'Funtastic Biscuits', logo: 'abl-funtastic-biscuits.png' },
  { name: 'Funtastic Cake', logo: 'abl-funtastic-cake.png' },
  { name: 'Yum Cake', logo: 'abl-yum.png' },
  { name: 'Fast Bread & Bun', logo: 'abl-fast.png' },
  { name: 'Hi5', logo: 'abl-hi5.png' },
  { name: 'Sunshine', logo: 'afml-sunshine.png' },
];

function Brands() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section className="brands-section" id="brands">
      <div className="brands-header">
        <h2 className="brands-title">OUR PRIDE BRANDS</h2>
        <div className="brands-nav">
          <button ref={prevRef}>&larr;</button>
          <button ref={nextRef}>&rarr;</button>
        </div>
      </div>

      <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={5}
        spaceBetween={0}
        loop
        speed={5000}
        autoplay={{ delay: 0, disableOnInteraction: false }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        breakpoints={{
          320: { slidesPerView: 2 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 5 },
        }}
        className="brands-swiper"
      >
        {brandList.map((brand, index) => (
          <SwiperSlide key={index}>
            <div className="brand-card">
              <img
                src={require(`../Assets/Images/${brand.logo}`)}
                alt={brand.name}
                className="spin-logo"
              />
              <p>{brand.name}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Brands;
